import * as React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover } from "antd";

export type SlideDetailsPopoverChipProps = {
  content: React.ReactNode;
  triggerClassName: string;
  ariaLabel: string;
  /** Wrapper around the info icon (matches precedent action chips by default). */
  iconWrapClassName?: string;
  /** Applied to `InfoCircleOutlined` (e.g. `!h-3.5 !w-3.5` or `!h-2.5 !w-2.5`). */
  iconClassName?: string;
  overlayStyle?: React.CSSProperties;
  /** Passed to Popover `overlayStyle.maxWidth` (px). @default 360 */
  overlayMaxWidth?: number;
};

const DEFAULT_ICON_WRAP =
  "inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center text-[#1f2328]";

/**
 * Click-triggered Details popover on a pill chip (shared by precedent pickers and presentation outline).
 */
export function SlideDetailsPopoverChip({
  content,
  triggerClassName,
  ariaLabel,
  iconWrapClassName = DEFAULT_ICON_WRAP,
  iconClassName = "!h-3.5 !w-3.5",
  overlayStyle,
  overlayMaxWidth = 360,
}: SlideDetailsPopoverChipProps) {
  return (
    <Popover content={content} trigger="click" overlayStyle={{ maxWidth: overlayMaxWidth, ...overlayStyle }}>
      <button
        type="button"
        className={triggerClassName}
        aria-label={ariaLabel}
        onPointerDown={(e) => e.stopPropagation()}
      >
        <span className={iconWrapClassName}>
          <InfoCircleOutlined className={`!block ${iconClassName}`} />
        </span>
        Details
      </button>
    </Popover>
  );
}
